/* eslint-disable no-nested-ternary */
import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { TicketDetail } from 'api/ticket';
import { StatusCode } from 'helpers/app.config';

function TicketDetails({
  dialogData,
  ticketDetail,
  children,
  haveChildren = false
}: {
  dialogData: {
    dataTickets?: string[];
    open?: boolean;
  };
  ticketDetail: TicketDetail;
  children?: ReactNode;
  haveChildren?: boolean;
}) {
  const { t } = useTranslation('global');
  return (
    <Box
      sx={{
        borderBottom:
          ticketDetail?.ticketStatusId === StatusCode?.Closed &&
          '2px solid black',
        marginBottom: '15px',
        fontSize: '14px'
      }}
    >
      {dialogData.dataTickets.length > 1 ? (
        <p>
          Ticket/s: {'  '}
          {dialogData.dataTickets.map((dataTicket: {}) => (
            <Chip key="dataTicket" label={dataTicket} />
          ))}
        </p>
      ) : haveChildren ? (
        children
      ) : (
        <>
          <p>
            {t('ticket.changeStatus.folioNumber')}:
            {dialogData.dataTickets.map((dataTicket: {}) => (
              <Chip key="dataTicket" label={dataTicket} />
            ))}
          </p>
          <p>
            {t('ubications.massiveLoad.client')}:{' '}
            {ticketDetail?.ticketClientName}
          </p>
          {/* <p>Servicio: {ticketDetail?.ticketServiceTypeId}</p>
          <p>Tipo Servicio: {ticketDetail?.ticketServiceTypeName}</p> */}
          <p>
            {t('ubications.addEditUbication.ubication')}:{' '}
            {ticketDetail?.ticketLocationName}
          </p>
          <p>
            {t('common.commonProperties.startDate2')}:{' '}
            {ticketDetail?.ticketStartDate
              ? dayjs
                  .utc(ticketDetail?.ticketStartDate)
                  .local()
                  .format('DD/MM/YYYY HH:mm')
              : t('ticket.changeStatus.noData')}
          </p>
        </>
      )}
    </Box>
  );
}

export default TicketDetails;
